import { Form } from "react-bootstrap";
import { addData, formatNumberOnly, format_mask, getData } from "./utils";
import React, { useState } from "react";
import BodyInputFormat from "./BodyInputFormat";
import { IFormInputDefault } from "./interfaces";

interface IFormInputNumberProps extends IFormInputDefault{
  numberOnly?: boolean;
}

export default function FormImputNumber({
  title,
  name,
  state,
  onChange,
  value,
  numberOnly = true,
  ...props
}:IFormInputNumberProps){

  const [Value, SetValue] = useState<any>(value?value:"");

  let {cleanable, onClear, ...props_aux} = props;
  if(state && name){
    props_aux["name"] = name;
    let v = "";
    if(state.model){
      v = getData(state.model,name) ?? ""
    }
    if(v){
      let {value} = format_mask(props.mask, v, Value);
      props_aux["value"] = value;
    } else {
      props_aux["value"] = "";
    }
  }

  return (
    <BodyInputFormat props={{...props,title}}>
      <Form.Control size="sm"
        onChange={(event)=>{
          
          let target = event.target;
          let aux_value:any = target.value;
          let start = target.selectionStart;
          
          if(formatNumberOnly(aux_value) !== "" && !parseInt(formatNumberOnly(aux_value)) && parseInt(formatNumberOnly(aux_value)) !== 0){
            return;
          }
          let {value, index, start_index} = format_mask(props.mask, aux_value, Value);
          if(aux_value[0])
          setTimeout(()=>{
            if(start)
            target.setSelectionRange(Math.min.apply(null, [index,start+start_index]), Math.min.apply(null, [index,start+start_index]));
          },1);
          
          if(state && name){
            state.setModel((old:any)=>{
              if(numberOnly){
                return addData(old,name,formatNumberOnly(value));
              } else {
                return addData(old,name,value);
              }
            });
          }
          SetValue(formatNumberOnly(value));
          if(onChange)onChange({...event, numberOnly: Value})
        }} 
        name={name}
        value={(()=>{
          if(Value && parseFloat(Value.toString())){
            let value_ftoc = parseFloat(Value.toString());
            if(value_ftoc < 0){
              value_ftoc *= -1;
            }
            return value_ftoc;
          }
          return "";
        })()}
        {...props_aux}
      />
    </BodyInputFormat>
  );
}